<template>
  <div>
    <component
    :is="quill_editor"
    id="quil-content"
    v-model="text"
    :options="editorOption"
    class="border-bottom-0"
    style="max-width: 100%; height: 150px;"
    @blur="changeText()"
    />
    <div
    :id="`quill-toolbar-${label}`"
    class="d-flex justify-content-end border-top-0"
    >
    <button class="ql-bold" />
    <button class="ql-italic" />
    <button class="ql-underline" />
    <button class="ql-align" />
    <button class="ql-link" />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    label: {
      type: String,
      required: true
    },
    prev_text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: `#quill-toolbar-${this.label}`
        },
        placeholder: this.$t('campaigns.writeHere')
      },
      text: '',
      quill_editor: null,
    }
  },
  created() {
    this.text = this.prev_text
  },
  async mounted() {
    const vue_quill_editor = (await import('vue-quill-editor'));
    this.quill_editor = vue_quill_editor.quillEditor;
    await import('quill/dist/quill.core.css');
    await import('quill/dist/quill.snow.css');
    await import('quill/dist/quill.bubble.css');
  },
  methods: {
    changeText() {
      this.$emit('changeText', this.text)
    }
  }
}
</script>